import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { SecretSanta } from "./SecretSanta";

function App() {
  return (
    <div className="App">
      <SecretSanta />
    </div>
  );
}

export default App;
